export const environment = {
  production: false,
  microservices: {
    ordersNew: "https://api-orders-new-dev.encargomio.com/api/v1/",
    marketplaceNew: "https://kbdw3zges4.execute-api.us-east-1.amazonaws.com/dev/marketplace/api/v1/",
    user: "https://api-user-dev.encargomio.com/api/v1/user/",
    management: "https://api-management-dev.encargomio.com/api/v1/management/",
  },
  firebase: {
    apiKey: "AIzaSyAijFdANf7CwmeJPVuivw69bsrwSjQAYk8",
    authDomain: "encargomio-ffa52.firebaseapp.com",
    projectId: "encargomio-ffa52",
    storageBucket: "encargomio-ffa52.appspot.com",
    messagingSenderId: "257092213866",
    appId: "1:257092213866:web:dd9af48b99943bdf0cbe13",
    vapidKey:
      "BEZzVfb2YyvXhgOVt-cQ_neVGLfPy4qydQfTs0-RSkBjXnr-syKGq_NzKPHljn06jX046LvEXNFsFq5Ckgr6kNI",
  },
};
